import { TargetsSourceDescription } from '@upright/ui/common/upright/core/impact-lenses/targets/source-description';
import { TargetsSourceTooltipContent } from '@upright/ui/common/upright/core/impact-lenses/targets/source-description/tooltip';

export const targetLensTexts = {
  SourceDescription: TargetsSourceDescription,
  SourceTooltipContent: TargetsSourceTooltipContent,
  LensTitle: () => {
    return <>Company targets</>;
  },
  LensDescription: () => {
    return <>Impact targets set by the company</>;
  },
  LensTooltipContent: () => {
    return (
      <>
        Impact targets that the company has set for itself. The shown targets may have been submitted directly by the
        company, or collected by Upright from the company's public reporting.
      </>
    );
  },
};
